import React from 'react';
import { fetchDataWithQuery } from '../restaurant-details/fetchData';
import restaurantPageQuery from './restaurantPageQuery.graphql';
import RestaurantPage, { type RestaurantPageData } from './RestaurantPage';

/**
 * Screen module for the rebuilt restaurant page (W3.1). With
 * ENABLE_NEW_DETAIL_PAGES on, the router and the RestaurantDetailsScreen entry
 * load this instead of screens/restaurant-details, which stays untouched (so a
 * build with the flag off is the original page, byte for byte). Same fetch --
 * slug parsing, 404, 301 for merged listings, error mapping -- with the
 * additive query.
 */
export const fetchData = fetchDataWithQuery(restaurantPageQuery);

export const RestaurantDetails = ({ data }: { data: RestaurantPageData }) => (
    <RestaurantPage data={data} />
);
